import React, { ReactNode, useEffect, useState } from 'react';
import ClassroomComparisonChart from './ClassroomComparisonChart';
import DistrictGradebook from 'models/analytics/DistrictGradebook';
import ClassroomUsageChart from './ClassroomUsageChart';
import {
  districtAdminService,
  DistrictStudent,
} from 'services/districtAdminService';
import useApiCall from 'contexts/ApiCall';
import { useUserContext } from 'contexts/UserContext';
import StudentComparisonChart from './StudentComparisonChart';
import StudentUsageChart from './StudentUsageChart';
import StudentProgressChart from './StudentImprovementChart';

interface DistrictAnalyticsProps {
  gradebook: DistrictGradebook;
}

const DistrictAnalytics: React.FC<DistrictAnalyticsProps> = ({ gradebook }) => {
  const { user } = useUserContext();
  const [students, setStudents] = useState<DistrictStudent[]>();
  const [selectedIdx, setSelectedIdx] = useState<number>(0);
  const tabLabels: string[] = [
    'Class Comparison',
    'Class Usage',
    'Student Comparison',
    'Student Usage',
    'Student Improvement',
  ];
  const tabContents: ReactNode[] = [
    <ClassroomComparisonChart gradebook={gradebook} />,
    <ClassroomUsageChart gradebook={gradebook} />,
    <StudentComparisonChart students={students} />,
    <StudentUsageChart students={students} />,
    <StudentProgressChart students={students} />,
    // <ClassroomGrowthChart gradebook={gradebook} />,
    // <StudentAnalyticsChart missedWords={missedWords} />,
  ];
  const makeApiCall = useApiCall();

  useEffect(() => {
    if (students || !user || !user?.district) return;
    makeApiCall(districtAdminService.getStudents, user?.district?.id)
      .then((resp) => setStudents(resp))
      .catch((error) => alert(error));
  }, [students, user, makeApiCall]);

  console.log(students);

  return (
    <div className="graph-container">
      <div className="student-insights">
        <div className="tab-headers">
          {tabLabels.map((label, idx) => (
            <span
              key={`tab-header-label-${idx}-${label}`}
              className={`tab-header-label ${
                idx === selectedIdx ? 'active-label' : ''
              }`}
              onClick={() => setSelectedIdx(idx)}
            >
              {label}
            </span>
          ))}
        </div>
        {tabContents[selectedIdx]}
      </div>
    </div>
  );
};

export default DistrictAnalytics;
